import { useTranslation } from '@/app/i18n/client'
import Image from 'next/image'
import { Button } from '@/components/ui/button'
import { navigateToLogin } from '@/lib/utils'
interface CompaniesListBlockerCardProps {
  subscription: string
}
const CompaniesListBlockerCard = async ({
  subscription,
}: CompaniesListBlockerCardProps) => {
  const { t } = useTranslation()
  const isNotLoggedIn = subscription == 'LoggedOut'
  const actionText = isNotLoggedIn ? t('Login') : t('Upgrade')
  return (
    <>
      <div className="flex flex-col w-full py-4 ">
        <div className="mt-[25px]">
          <p className="text-[#222222] text-[30px] tracking-[normal] text-left ">
            {`${actionText} ${t('to unlock more Companies data')}`}
          </p>
          <div className="flex flex-col justify-center items-center border-t-2 border-[solid] border-[#ededed] gap-3 mt-[40px] p-5 shadow-sm">
            <div className="flex flex-row gap-2">
              <Image
                height={17.5}
                width={18.9}
                alt="Warning-Icon"
                src={'/assets/Icons/WarningIcon.svg'}
              />
              <p className="text-[20px] text-[#222222] font-bold">
                {`${t('Your limit exhausted')} !`}
              </p>
            </div>
            <p className="text-[14px] text-[#6f6f6f]">
              {`${actionText} ${t('to unlock more premium features and benefits')}.`}
            </p>
            {!isNotLoggedIn && (
              <div className="flex flex-row items-center gap-2">
                <label className="text-sm text-[#6f6f6f]">
                  {t('Current Subscription')}:
                </label>
                <span className="font-semibold">{t(subscription)}</span>
              </div>
            )}
            {isNotLoggedIn ? (
              <Button
                variant="secondary"
                size="sx"
                className="mt-4 py-3 text-[14px] font-bold"
              >
                <a href={navigateToLogin('login', '')}>{t('LOGIN')}</a>
              </Button>
            ) : (
              <Button
                variant="secondary"
                size="sx"
                className="mt-4 py-3  text-[14px] font-bold"
              >
                <a href={'/solutions/for_buyers'}>{t('UPGRADE')}</a>
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default CompaniesListBlockerCard
